import { action, computed, flow, observable } from 'mobx';
import { computedFn } from 'mobx-utils';

type Query = {
  name: string;
  state: {
    pending?: boolean;
    error?: boolean;
    success?: boolean;
  };
  ts?: number;
};

type QueryList = {
  [key: string]: Query;
  auth: Query;
  sync: Query;
};

export default class QueryStore {
  @observable public accessor list: Partial<QueryList> = {};

  @computed public get isBusy() {
    return Object.values(this.list).some(
      (query) => query && query.state.pending,
    );
  }

  get = computedFn(
    (name: keyof QueryList): Query =>
      this.list[name] || { name: '', state: {} },
  );

  @action.bound public set(query: Query) {
    this.list[query.name] = query;
  }

  @flow.bound
  *withQuery<T>(name: string, fn: () => Promise<T>) {
    try {
      this.set({
        ...this.get(name),
        ts: Date.now(),
        state: {
          ...this.get(name).state,
          pending: true,
        },
        name,
      });
      const response: T = yield fn();
      this.set({
        ...this.get(name),
        state: {
          ...this.get(name).state,
          success: true,
        },
      });
      return response;
    } catch (e) {
      this.set({
        ...this.get(name),
        state: {
          ...this.get(name).state,
          error: true,
        },
      });

      throw e;
    } finally {
      this.set({
        ...this.get(name),
        state: {
          ...this.get(name).state,
          pending: false,
        },
      });
    }
  }
}
